<template>
  <div class="people-seiji">
    <People
    :isReverse="false" 
    :image="require('../assets/people_seiji/hero.jpg')" 
    :name="require('../assets/people_seiji/name.svg')" 
    mainCatch="ソフト・メカ・エレキ。<br>
            全ての技術を融合させ、<br>
            豆蔵オリジナル<br>
            ロボットが誕生した。" 
    background="技術コンサルティング事業部<br>
              第一コンサルティング部<br>
              主幹コンサルタント" 
    history="大学時代はAIを研究。宇宙に対する憧れから、大手電機メーカーに入社し、通信衛星の地上局側のソフトウェア開発を担当。「幅広い開発案件を経験して、ソフトウェアの技術力をより高めたい」と、2008年に豆蔵に転職。入社以来、一貫して組込み系の開発を担当。現在は、主にロボット領域のコンサルティングおよびソフトウェア開発に携わっている。" 
    >
      <PeopleArticle
        :isReverse="false" 
        text='<p class="catch">
              ソフトウェアの知見を活かして、<br>
              最速でロボット事業を軌道に乗せた。
            </p>
            <p class="body">
              豆蔵のロボット開発は、2013年から始まりました。ある海外のロボットメーカーから産業用ロボットのコントローラ開発の依頼を受けたのがきっかけです。ロボットは未経験でしたが、自動車や複写機などの組込みシステムの開発で培ってきたオブジェクト指向やモデルベース開発の技術を応用することで、<i>２年で基本機能を開発して展示会に出展し、４年で国内ロボットメーカーと同等の機能・性能を達成しました。</i>コントローラの開発に成功したことで、ロボットアームの開発も依頼を受けました。当社はメカ設計が専門ではなかったので、かなり無茶ぶりでしたが、どうにか成功させることができました。これにより、ロボットシステムを構成するメカ、エレキ、ソフト全ての技術要素を獲得することができ、ロボット領域への進出の足がかりができました。
            </p>
            <p class="catch">
              実機レスでのシミュレーション環境を構築し、<br>
              産学連携で技術の壁を超えた。
            </p>
            <p class="body">
              このプロジェクトが成功した理由は、2つあります。<br>
              1つ目は、<i>開発期間を短縮する設計手法を確立</i>したことです。当社が得意とするモデルベース開発技術をハードウェア開発にも応用しました。ハードウェアをシミュレートするモデルをソフトウェア上に構築することにより、実機レスで開発する環境を整備しました。ハードウェアの製造には時間が掛かってしまうので、シミュレーション環境上で開発することで、開発と評価に要する時間を大幅に削減することができました。
            </p>
            <p class="body">
              2つ目は、技術的な壁を乗り越えるために、<i>産学連携のアプローチをとった</i>こと。ロボット工学の知見を有していなかったため、東京農工大学の遠山茂樹教授との共同研究を立ち上げました。当社はモデルベース開発技術、東京農工大学はロボット工学という両者の得意分野を融合させて、開発期間を短縮するロボットアームの設計手法を確立させることができました。
            </p>' 
        :image="require('../assets/people_seiji/image01.jpg')" 
      />
      <PeopleArticle
        :isReverse="false" 
        text='<p class="catch">
              8か月で開発した、自社ロボット「Beanus」。<br>
              国際ロボット展で高評価を獲得。
            </p>
            <p class="body">
              メカ・エレキ・ソフトの開発技術を飛躍的に向上させることで、クライアントであるロボットメーカーの要求に応えられるようになりました。次の段階として、より多くのクライアントにプロモーションを行うために、<i>自社で７軸の協働ロボット「Beanus」を開発。</i>2017年4月にプロジェクトを発足して11月の国際ロボット展に出展しました。つまり、<i>8か月という短期間で、ゼロから1台のロボットをつくり上げたのです。</i>この「Beanus」は、国際ロボット展で高い評価を獲得し、「ソフトウェア会社が、ハードウェアも含めて8か月でつくった」と伝えると、来場者の皆さんは驚いていらっしゃいました。
            </p>
            <p class="body">
              もちろん、この過程の中で苦労はしています。特に、ロボットが振動する問題には苦労しました。「Beanus」では3Dプリンタでロボットアームを製造したのですが、最初は振動が酷く、制御プログラムで工夫しても解消できませんでした。最終的には問題のある部品を特定して解消できましたが、展示会というゴールが決まっているなかで、とにかく時間との戦いでしたね。<i>問題が解消して、思った通りに動いたときには感動しました。</i>
            </p>' 
        :image="require('../assets/people_seiji/image02.jpg')" 
      />
      <PeopleArticle
        :isReverse="false" 
        text='<p class="catch">
              双腕、オープンソースやFA。<br>
              ロボット開発支援の幅が一気に拡がった。
            </p>
            <p class="body">
              2017年の自社ロボットの開発以降は、様々な依頼をいただくようになりました。<i>双腕ロボットの研究</i>に着手したり、<i>「ROS（Robot Operating System）」というオープンソースソフトウェアを用いた開発案件</i>にも取り組んだりしています。前者においては、今までは単腕のみだったものが、双腕になって制御の複雑さも倍増しました。非常に難易度の高いプロジェクトではありますが、<i>こちらも10か月という短期間で進めています。</i>
            </p>
            <p class="body">
              これらのロボットに関する依頼に加えて、<i>ファクトリーオートメーションの開発案件</i>も増えています。これまではロボットのメーカー側のビジネスが主でしたが、今後はロボットを利用するユーザー側へのアプローチも強めていきます。私たちには、メーカー側で培った経験から、ロボットに関する知識に強みがありますので、十分に戦えると思っています。ユーザー側の企業数は、メーカー側よりも圧倒的に多いので、ビジネスの拡大を目指すに当たっては、このマーケットをぜひ取りたいですね。

            </p>
            <p class="catch">
              ロボットに閉じない。<br>
              より広いスキルを習得していきたい。
            </p>
            <p class="body">
              私自身は、コンサルタントとしてさらにレベルアップしていきたいです。技術革新が早い分野ですので、まだまだ専門知識として習得するべきことは多々あります。現状はロボット開発がメインミッションなのですが、<i>そこに閉じずに、ソフトウェア開発におけるコンサルティングのレベルを上げていきたいと考えています。</i>特に、モデルベース開発やプロセス標準化において、高い技術力を持つ社員が多いので、彼らからより深い知識を習得していきたいですね。
            </p>' 
        :image="require('../assets/people_seiji/image03.jpg')" 
      />
      <PeopleArticle
        :isReverse="false" 
        text='<p class="catch">
              自ら学びながら、<br>
              他者の意見を受け入れられる柔軟性のある人。
            </p>
            <p class="body">
              組込み開発領域で求めている人物像は、<i>「自己学習ができて素直な人」です。</i>「自己学習できる人」は、<i>自発的に新しい知識を吸収できる人</i>を指します。この領域はソフトだけではなく、メカやエレキも絡んでくるので、総合的な知見が求められます。しかも、IoTやオープンソースといった新しい枠組みが台頭し、技術の更新スピードが速いのが特徴です。そのような環境下で、「誰かが自分に教えてくれるだろう」というスタンスでは、キャッチアップしていくのは難しい。常に自分で学び続ける。その姿勢が、コンサルタントやエンジニアとして価値を発揮し続けるためには、とても大切になります。
            </p>
            <p class="body">
              次に「素直な人」。これは、<i>他の人の意見に耳を傾けて、素直に取り入れる柔軟性を持っているかどうかです。</i>コンサルタントとして活躍するためには、自分の考えを貫くことも確かに必要です。ただし、より大切なのはクライアント企業が長年培ってきたものを、まずは受け入れることだと思います。それを踏まえてコンサルティングを行った方が、良い結果につながることが多いですね。<i>自己の思考をガチガチに固めるのではなく、他者を受け入れる柔らかさを持ちながら、</i>組込み領域を進化させていただける人をお待ちしています。
            </p>' 
        :image="require('../assets/people_seiji/image04.jpg')" 
      />
    </People>
  </div>
</template>

<script>
// @ is an alias to /src
import People from '@/components/people/People.vue';
import PeopleArticle from '@/components/people/PeopleArticle.vue';
export default {
  name: 'people-seiji',
  components: {
    People,
    PeopleArticle
  },
}
</script>

<style lang="scss" scoped>
.people-seiji {
  width: 100%;
  overflow: hidden;
}
</style>